import WithTracker from "components/Tracker";

import LandingPage from "containers/LandingPage";
import HomePage from "containers/HomePage";
import ExchangePage from "containers/ExchangePage";

export default [
  {
    path: "/",
    exact: true,
    key: "landingPage",
    element: <LandingPage />,
  },
  {
    path: "/home",
    exact: true,
    key: "HomePage",
    element: (
      <WithTracker ga="view_home">
        <HomePage />
      </WithTracker>
    ),
  },
  {
    path: "/exchange",
    exact: true,
    key: "ExchangePage",
    element: (
      <WithTracker ga="view_exchange">
        <ExchangePage />
      </WithTracker>
    ),
  },
];
